/*
Copyright © 2021 EPAM Systems, Inc. All Rights Reserved.
All information contained herein is, and remains the property of EPAM Systems, Inc.
and/or its suppliers and is protected by international intellectual property law.
Dissemination of this information or reproduction of this material is strictly
forbidden, unless prior written permission is obtained from EPAM Systems, Inc
*/
import React, { useEffect } from 'react';
import './modal.scss';

const modal = require('b_').with('modal');
const button = require('b_').with('button');

export const Modal = ({
    title,
    message,
    cancelTitle,
    confirmTitle,
    onCancel = null,
    onConfirm = null,
    onClose = null,
    reverseConfirmButton,
    showCloseButton = true,
}) => {
    useEffect(() => {
        document.body.style.overflow = 'hidden';

        return () => {
            document.body.style.overflow = 'unset';
        };
    }, []);

    const handleClose = () => {
        if (onClose) {
            onClose();
        }
    };

    const handleCancel = () => {
        if (onCancel) {
            onCancel();
        }
        handleClose();
    };

    const handleConfirm = () => {
        if (onConfirm) {
            onConfirm();
        }
        handleClose();
    };

    const renderMessage = () => {
        if (React.isValidElement(message)) {
            return message;
        }
        return <div>{message}</div>;
    };

    return (
        <div className={modal()}>
            <div className={modal('window')}>
                <div className={modal('header')}>
                    <div className={modal('title')}>{title}</div>
                    {showCloseButton && (
                        <button
                            className={`${modal('close')} ${button()} ${button({ close: true })}`}
                            onClick={handleClose}
                            aria-label="Закрыть"
                        />
                    )}
                </div>

                <div className={modal('body')}>
                    <div className={modal('message')}>
                        {renderMessage()}
                    </div>
                </div>

                <div className={modal('footer')}>
                    {cancelTitle && (
                        <button
                            className={`${button()} ${button({ reverse: true })} ${modal('footer-button')}`}
                            onClick={handleCancel}
                            style={{ marginRight: '8px' }}
                        >
                            {cancelTitle}
                        </button>
                    )}
                    {confirmTitle && (
                        <button
                            className={`${button()} ${reverseConfirmButton ? button({ reverse: true }) : ''} ${modal('footer-button')}`}
                            onClick={handleConfirm}
                        >
                            {confirmTitle}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};
